const state = {
    data: null
}
try {
    const app_data = document.querySelector('meta[name="app-data"]').content
    state.data = JSON.parse(app_data)
} catch (e) {
    console.log(e)
}

const getters = {
}

const mutations = {
    setData (state, data) {
        state.data = data ? data : null
    }
}

const actions = {
    async data (context) {
        const response = await axios.get('/api/v1/app/data').catch(error => error.response || null)
        context.commit('setData', response ? response.data.data : null)
        return response
    },
//    async exchange_money (context, data) {
//        return axios.post('/api/v1/app/exchange_money', data)
//            .then((response) => {
//                return response
//            })
//            .catch((error) => {
//                return Promise.reject(error.response.data.errors || {})
//            })
//    },
    async ogp (context, url) {
        return axios.get(url)
            .then((response) => {
                const el = new DOMParser().parseFromString(text, 'text/html')
                const headEls = (el.head.children)
                Array.from(headEls).map(v => {
                    const prop = v.getAttribute('property')
                    if (!prop) return;
                    console.log(prop, v.getAttribute('content'))
                })
                return {hoge:1}
            })
            .catch((error) => {
                return {}
                return Promise.reject(error.response.data.errors || {})
            })
    },
    async file (context, params) {
        const response = await axios.get('/api/v1/app/file', {
            params: params,
        }).catch(error => error.response || null)
        return response
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

